<template>
    <div class="animated fadeIn">
        <b-row> 
            <b-form
            @submit.prevent="validateForm('form-1')"
            data-vv-scope="form-1">
                <hr/>
                <h6 class="mt-4"><b>Driver Info</b></h6>
                <br />
                <b-row>
                    <b-col sm="3">
                        <b-form-group>
                            <div class="d-flex">  
                            <label for="first name">Driver First Name</label>&nbsp;<span style="color: red;">*</span>
                            </div>
                        <b-form-input
                            type="text"
                            name="first name"
                            v-model="customer.driverfirstname"
                            v-validate="'required|alpha|min:3|max:30'"
                            :class="{
                            input: true,
                            'is-invalid': errors.has('form-1.first name'),
                            }"
                            placeholder="Enter First Name"
                        >
                        </b-form-input>
                        <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                            <i
                                class="fa fa-warning"
                                v-show="errors.has('first name')"
                            ></i>
                            </span>
                            <span
                            style="width:240px"
                            v-show="errors.has('form-1.first name')"
                            class="help text-danger"
                            >{{ errors.first("form-1.first name") }}</span
                            >
                        </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group>
                            <div class="d-flex">  
                        <label for="last name">Driver Last Name</label>&nbsp;<span style="color: red;">*</span>
                        </div>
                        <b-input-group class="mb-3">
                            <b-form-input
                            class="input"
                            type="text"
                            name="last name"
                            v-model="customer.driverlastname"
                            v-validate="'required|alpha|min:3|max:30'"
                            :class="{
                                input: true,
                                'is-invalid': errors.has('form-1.last name'),
                            }"
                            placeholder="Enter Last Name"
                            >
                            </b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                            <i
                                class="fa fa-warning"
                                v-show="errors.has('last name')"
                            ></i>
                            </span>
                            <span
                            style="width:240px"
                            v-show="errors.has('form-1.last name')"
                            class="help text-danger"
                            >{{ errors.first("form-1.last name") }}</span
                            >
                        </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group>
                            <div class="d-flex">  
                        <label for="addmobilenumber">Driver Mobile No</label>&nbsp;<span style="color: red;">*</span>
                        </div>
                        <b-input-group class="mb-3">
                            <b-form-input
                            class="input"
                            type="text"
                            id="addmobilenumber"
                            name="mobile number"
                            maxlength="10"
                            v-model="customer.drivermobilenumber"
                            v-validate="'required|digits:10'"
                            :class="{
                                input: true,
                                'is-invalid': errors.has('form-1.mobile number'),
                            }"
                            placeholder="Enter Mobile Number"
                            >
                            </b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                            <i
                                class="fa fa-warning"
                                v-show="errors.has('mobile number')"
                            ></i>
                            </span>
                            <code
                            v-show="errors.has('form-1.mobile number')"
                            id="addmblnbrmsg"
                            class="help text-danger"
                            >{{ errors.first("form-1.mobile number") }}
                            </code>
                        </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group>
                            <div class="d-flex">  
                        <label for="vehicleno ">Vehicle Number</label>&nbsp;<span style="color: red;">*</span>
                        </div>
                        <b-input-group class="mb-3">
                            <b-form-input
                            class="input"
                            type="text"
                            v-model="customer.vehicleno"
                            name="vehicleno"
                            id="vehicleno"
                            v-validate="'required'"
                            :class="{
                                input: true,
                                'is-invalid': errors.has('form-1.vehicleno'),
                            }"
                            placeholder="Enter Vehicle Number"
                            >
                            </b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-3">
                            <span
                            v-show="errors.has('form-1.vehicleno')"
                            class="help text-danger"
                            >{{ errors.first("form-1.vehicleno") }} 
                            </span>
                        </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group>
                            <div class="d-flex">  
                            <label for="fueltype">Fuel Type</label>&nbsp;<span style="color: red;">*</span>
                            </div>
                            <v-select v-model="customer.fueltype" name="fueltype" :options="fuelTypeOptions" placeholder="-- Select Fuel Type --" v-validate="'required'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.fueltype'),
                                    }"></v-select>
                                <b-input-group class="mb-3">
                                    <span
                                        style="width:240px"
                                        v-show="errors.has('form-1.fueltype')"
                                        class="help text-danger"
                                        >{{
                                        errors.first("form-1.fueltype")
                                        }}</span
                                    >
                                </b-input-group>                               
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group>
                         <div class="d-flex">  
                        <label for="drivinglicense">Driving License</label>&nbsp;<span style="color: red;">*</span></div>
                        <b-input-group class="mb-3">
                            <b-form-input
                            class="input"
                            type="text"
                            v-model="customer.drivinglicense"
                            name="drivinglicense"
                            id="drivinglicense"
                            placeholder="Enter Driving License"
                            v-validate="'required'"
                            :class="{
                                input: true,
                                'is-invalid': errors.has('form-1.drivinglicense'),
                            }"
                            >
                            </b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-3">
                            <span
                            v-show="errors.has('form-1.drivinglicense')"
                            class="help text-danger"
                            >{{ errors.first("form-1.drivinglicense") }} 
                            </span>
                        </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group>
                            <div class="d-flex">  
                            <label for="password">Password</label>&nbsp;<span style="color: red;">*</span></div>
                            <b-input-group class="mb-3">
                            <b-form-input
                                class="input"
                                type="password"
                                name="password"
                                minlength="6"
                                maxlength="14"
                                v-model="customer.password"
                                v-validate="'required|min:6|max:14'"
                                :class="{
                                input: true,
                                'is-invalid': errors.has('form-1.password'),
                                }"
                                placeholder="Enter Password"
                            >
                            </b-form-input>
                            </b-input-group>
                            <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                                <i
                                class="fa fa-warning"
                                v-show="errors.has('password')"
                                ></i>
                            </span>
                            <code
                                v-show="errors.has('form-1.password')"
                                id="passwordtxt"
                                class="help text-danger"
                                >{{ errors.first("form-1.password") }}
                            </code>
                            </b-input-group>
                        </b-form-group>
                    </b-col>                    
                    <b-col sm="3">
                        <b-form-group>
                            <div class="d-flex">  
                        <label for="registration_no ">Registration certificate No</label></div>
                        <b-input-group class="mb-3">
                            <b-form-input
                            class="input"
                            type="text"
                            v-model="customer.registration_no"
                            name="registration_no"
                            id="registration_no"
                            placeholder="Enter Registration certificate No"
                            >
                            </b-form-input>
                        </b-input-group>
                      
                        </b-form-group>
                    </b-col>
                    <b-col sm="3">
                        <b-form-group class="mb-3">
                            <div class="d-flex">  
                            <label for="driverslicensenumber"> Upload DL</label></div>
                            <b-form-file variant="primary"
                                    type="file"
                                    v-model="customer.driverlicenseFile"
                                    placeholder="Upload DL" 
                                    class="custom-border"
                                    @change="driverLicenseFileUplod($event)"
                                    id="driver_license" 
                                    name="driver_license">
                            </b-form-file>
                           
                        </b-form-group> 
                    </b-col>                 
                    <b-col sm="3" >
                      <b-form-group>
                        <div class="d-flex">  
                        <label for="hub_name">Select Hub</label>&nbsp;<span style="color: red;">*</span></div>
                            <v-select v-model="adminHub" :options="optionHubid" placeholder="-- Select Hub --"  
                             name="hub_name"
                            v-validate="'required'"
                            :class="{
                                'is-invalid': errors.has('form-1.hub_name')
                            }"></v-select>
                            <b-input-group class="mb-3">
                            <span
                                style="width:240px"
                                v-show="errors.has('form-1.hub_name')"
                                class="help text-danger"
                                >{{errors.first("form-1.hub_name")}}</span
                            >
                            </b-input-group>
                            
                       </b-form-group>
                    </b-col>                        
                </b-row>
                <hr />
                    <br />
                     <h6><b>Vehicle Info</b></h6>
                    <br />
                    <b-row>
                        <b-col sm="3">
                            <b-form-group>
                                <div class="d-flex">  
                                <label for="vehicletypesize">Vehicle Size</label>&nbsp;<span style="color: red;">*</span></div>
                                    <v-select v-model="customer.vehicletypesize" name="vehicletypesize" :options="vehicleTypeSizeOptions" @input="addVehicleTypeSize" placeholder="-- Select Vehicle Size --" v-validate="'required'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.vehicletypesize'),
                                    }"
                                    ></v-select>
                                    <b-input-group class="mb-3">
                                    <span
                                        style="width:240px"
                                        v-show="errors.has('form-1.vehicletypesize')"
                                        class="help text-danger"
                                        >{{
                                        errors.first("form-1.vehicletypesize")
                                        }}</span
                                    >
                                    </b-input-group>       
                            </b-form-group>
                            
                        </b-col>
                        <b-col sm="3" v-if="vehicletypesizetext">
                            <b-form-group>
                                <div class="d-flex">  
                                <label for="vehicle_type_size">Vehicle Size</label></div>
                                <b-form-input
                                type="text"
                                name="vehicle_type_size"
                                v-validate="'required|numeric'"
                                v-model="customer.vehicletypesizetext"
                                
                                placeholder="Enter Vehicle Size"
                                >
                                </b-form-input>
                                <!-- <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning"
                                    v-show="errors.has('vehicle_type_size')"
                                    ></i>
                                </span>
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-1.vehicle_type_size')"
                                    class="help text-danger"
                                    >{{ errors.first("form-1.vehicle_type_size") }}</span
                                >
                                </b-input-group> -->
                            </b-form-group>
                        </b-col>                       
                        <b-col sm="3">
                            <b-form-group>
                                <div class="d-flex">  
                                <label for="pucnumberfile">Upload PUC</label></div>
                                <b-form-file
                                        type="file"
                                        v-model="customer.pucnumberfile"
                                        @change="pucFileUplod1($event)"
                                        id="puc_file" 
                                        placeholder="Upload PUC" 
                                        class="custom-border"
                                        name="puc_file"
                                        >
                                    Upload PUC
                                </b-form-file>
                                
                            </b-form-group>
                        </b-col>
                        <b-col sm="3" class="mb-3">
                            <b-form-group>
                                <div class="d-flex">  
                                <label>Upload RC</label></div>
                                <b-form-file
                                        placeholder="Upload RC" 
                                        class="custom-border"
                                        type="file"
                                        v-model="customer.registrationfile"
                                        @change="registrationFileUplod($event)"
                                        id="registration_file" 
                                        name="registration_file"
                                        >
                                    Upload RC
                                </b-form-file>
                            
                            </b-form-group>
                        </b-col>
                        <b-col sm="3" class="mb-3">
                            <b-form-group>
                                <div class="d-flex">  
                                <label for="permitfile">Upload Permit</label></div>
                                <b-form-file
                                        placeholder="Upload Permit" 
                                        class="custom-border"
                                        type="file"
                                        v-model="customer.permitfile"
                                        @change="permitFileUplod($event)"
                                        id="permit_file" 
                                        name="permit_file"
                                        >
                                </b-form-file>
                                
                            </b-form-group>
                        </b-col>
                        <b-col sm="3" class="mb-3">
                            <b-form-group>
                                <div class="d-flex">  
                                <label>Upload Insurance</label></div>
                                <b-form-file
                                        placeholder="Upload Insurance File" 
                                        class="custom-border"
                                        type="file"
                                        v-model="customer.insurancefile"
                                        @change="insuranceFileUplod($event)"
                                        id="insurance_file" 
                                        name="insurance_file"
                                        >
                                </b-form-file>
                            
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <div sm="3" class="mb-3">
                                <b-form-group> 
                                    <div class="d-flex">  
                                    <label>Payment Type</label></div>
                                    <b-form-radio-group 
                                        v-model="customer.paymenttype" 
                                        :options="[
                                            { text: 'Daily', value: 'tripend' }, 
                                            { text: 'Weekly', value: 'weekly' },
                                            { text: 'Monthly', value: 'monthly' }
                                        ]"
                                        name="payment_type"
                                        id="payment_type"
                                        
                                    >
                                    </b-form-radio-group>
                                <b-input-group class="mb-3">
                                    <span
                                        style="width:240px"
                                        v-show="errors.has('form-1.payment_type')"
                                        class="help text-danger"
                                        >{{
                                        errors.first("form-1.payment_type")
                                        }}</span
                                    >
                                    </b-input-group> 
                                </b-form-group>
                            </div>
                        </b-col>
                    </b-row>

                    <hr />
                    <br />
                    <h6><b>Transporter Info</b></h6>
                     <b-row >
                        <b-col sm="4"> 
                        </b-col>
                        <b-col sm="4"> 
                            <b-form-group>
                                <div class="d-flex">  
                                    <label for="selecttransporterCompanyName"><b>Select Existing</b></label>&nbsp;<span style="color: red;">*</span>
                                </div>
                                <v-select v-model="selecttransporterCompanyName" :options="optionmailid" @input="updateTransporterDetails" placeholder="-- Select Company --"></v-select>
                                
                            </b-form-group>
                        </b-col>
                        <b-col sm="4"> 
                         </b-col>
                    </b-row >
                    <b-row >
                       
                       
                        <b-col sm="3">
                            <b-form-group> <label for="vendortype">Type of Vendor</label>&nbsp;<span style="color: red;">*</span>
                                <b-form-radio-group 
                                    id="vendor type" 
                                    v-model="customer.vendortype" 
                                    v-validate="'required'"
                                    :options="[
                                        { text: 'Aggregator', value: 'aggregator' }, 
                                        { text: 'Normal', value: 'normal' }
                                    ]"
                                    name="vendor type"
                                    :class="{input: true,'is-invalid': errors.has('form-1.vendor type'),}"
                                >
                                </b-form-radio-group>
                                <b-input-group class="mb-3">
                                 <span style="width:240px" v-show="errors.has('form-1.vendor type')" class="help text-danger">{{ errors.first("form-1.vendor type") }}</span>
                                </b-input-group>
                            </b-form-group>

                        </b-col>
                        <b-col sm="3" >
                            <b-form-group>
                                <div class="d-flex">  
                            <label for="transporter_company_name">Transporter Company Name</label>&nbsp;<span style="color: red;">*</span></div>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text" v-model="customer.transporter_company_name" name="transporter_company_name" id="transporter_company_name" v-validate="'required|min:3|max:50'" :class="{
                                input: true,'is-invalid': errors.has('form-1.transporter_company_name'),}" placeholder="Enter Transporter Company Name"></b-form-input>
                            </b-input-group>
                            <b-input-group class="mb-3">
                                <span style="width:240px" v-show="errors.has('form-1.transporter_company_name')" class="help text-danger">{{ errors.first("form-1.transporter_company_name") }}</span>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3" >
                            <b-form-group>
                                <div class="d-flex">  
                            <label for="transporter_emailid">Transporter Email</label>&nbsp;<span style="color: red;">*</span></div>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text" v-model="customer.transporter_emailid" name="transporter_emailid" id="transporter_emailid" v-validate="'required|email'" :class="{input: true,'is-invalid': errors.has('form-1.transporter_emailid'),}" placeholder="Enter Transporter Email"></b-form-input>
                            </b-input-group>
                            <b-input-group class="mb-3">
                                <span style="width:240px" v-show="errors.has('form-1.transporter_emailid')" class="help text-danger">{{ errors.first("form-1.transporter_emailid") }}</span>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <div class="d-flex">  
                            <label for="transporter_name"> Transporter Name</label>&nbsp;<span style="color: red;">*</span></div>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text" v-model="customer.transporter_name" name="transporter_name" id="transporter_name" v-validate="'required'" :class="{
                                    input: true,'is-invalid': errors.has( 'form-1.transporter_name'),}" placeholder="Enter Transporter Name"></b-form-input>
                            </b-input-group>
                            <b-input-group class="mb-3">
                                <span style="width:240px" v-show="errors.has('form-1.transporter_name')" class="help text-danger">{{ errors.first("form-1.transporter_name") }}</span>
                            </b-input-group>
                            </b-form-group>
                        </b-col>                       
                        <b-col sm="3">
                            <b-form-group>
                                <label for="transporter_gst_no">Tin Number / GST Number</label>&nbsp;
                                <b-form-input name="GST Number" type="text"
                                    v-model="customer.transporter_gst_no" @input="checkGSTlength(customer.transporter_gst_no)" 
                                    placeholder="Enter Tin Number / GST Number"
                                   >
                                </b-form-input>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                <i class="fa fa-warning" v-show="errors.has('GST Number')"></i>
                                </span>
                                <code v-show="errors.has('form-1.GST Number')" id="GST Number" class="help text-danger">{{ errors.first("form-1.GST Number") }}
                                </code>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3" class="mt-1">
                            <b-form-group>
                                <label for="promotername"></label>&nbsp;
                                <button type="button" class="btn btn-outline-success btn-md mt-4" v-if="showverifybutton" @click="verifyGSTNo()" style="margin-top: 2.5rem !important;">Verify</button>&nbsp;
                                <button type="button" class="btn btn-outline-danger btn-md mt-4" v-if="removeGST" @click="removevalue()"  style="margin-top: 2.5rem !important;">X</button>
                            </b-form-group>
                        </b-col>                       
                        <b-col sm="3">
                            <b-form-group>
                                <div class="d-flex">  
                            <label for="transporter_mobilenumber">Transporter Mobile No</label>&nbsp;<span style="color: red;">*</span></div>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text" id="transporter_mobilenumber" name="transporter_mobilenumber" maxlength="10" v-model="customer.transporter_mobilenumber" v-validate="'required|digits:10'" :class="{
                                    input: true,'is-invalid': errors.has('form-1.transporter_mobilenumber'),}" placeholder="Enter Mobile Number"></b-form-input>
                            </b-input-group>
                            <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                <i class="fa fa-warning" v-show="errors.has('transporter_mobilenumber')"></i>
                                </span>
                                <code v-show="errors.has('form-1.transporter_mobilenumber')" id="addmblnbrmsg" class="help text-danger">{{ errors.first("form-1.mobile number") }}
                                </code>
                            </b-input-group>
                            </b-form-group>
                        </b-col>                        
                        <b-col sm="3">
                            <b-form-group>
                                <div class="d-flex">  
                            <label for="pan">PAN</label></div>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text" id="pan" name="pan" v-model="customer.pan"  placeholder="Enter PAN Number"></b-form-input>
                            </b-input-group>
                            
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <div class="d-flex">  
                            <label for="adhaarno">Aadhaar</label></div>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text" id="adhaar" name="adhaar" v-model="customer.aadhar"  placeholder="Enter Aadhaar Number"></b-form-input>
                            </b-input-group>
                           
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <div class="d-flex">  
                                <label for="bankcancelledcheque">Bank Cancelled Cheque</label>
                                </div>
                                <b-form-file
                                    type="file"
                                    v-model="customer.bankcancelledcheque"
                                    placeholder="Bank Cancelled Cheque" 
                                    @change="selectBankChequeFile($event)"
                                    class="custom-border"
                                   
                                    id="bankcancelledcheque" 
                                    name="bankcancelledcheque" :class="{
                                    input: true,'is-invalid': errors.has('form-1.bankcancelledcheque'),}"                                     >
                                    <template v-slot:file-name >
                                        {{ bankFileName }}
                                    </template>
                                </b-form-file>
                            <b-input-group class="mb-3">
                                <code v-show="errors.has('form-1.bankcancelledcheque')" id="addpanerrmsg" class="help text-danger">{{ errors.first("form-1.bankcancelledcheque") }}
                                </code>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                            <label for="gstincertificate">GSTIN Certificate</label>&nbsp;
                                <b-form-file
                                    type="file"
                                    v-model="customer.gstincertificate"
                                    placeholder="GSTIN Certificate" 
                                    @change="selectGstinCertficateFile($event)"
                                    class="custom-border"
                                    id="gstincertificate" name="gstincertificate" 
                                     :class="{
                                    input: true,'is-invalid': errors.has('form-1.gstincertificate'),}"
                                    >
                                    <template v-slot:file-name>
                                        {{ gstinCertficateFilename }}
                                    </template>
                                </b-form-file>
                            <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                <i class="fa fa-warning" v-show="errors.has('gstincertificate')"></i>
                                </span>
                                <code v-show="errors.has('form-1.gstincertificate')" id="gstincertficateerrmsg" class="help text-danger">{{ errors.first("form-1.gstincertificate") }}
                                </code>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                            <label for="pincode">Pincode</label>&nbsp;
                            <v-select v-model="customer.pincode" :options="pincodes" placeholder="-- Select Pincode --" @change="pincodeChange(customer.pincode)"></v-select>
                            <b-input-group class="mb-3" >
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-1.pincode')"
                                    class="help text-danger"
                                   
                                    >{{
                                    errors.first("form-1.pincode")
                                    }}</span
                                >
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <div class="d-flex">  
                            <label for="address">Address</label></div>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" 
                                type="text" id="address" name="address" v-model="customer.address" :class="{
                                    input: true,'is-invalid': errors.has('form-1.address'),}" placeholder="Enter Address"></b-form-input>
                            </b-input-group>
                            <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                <i class="fa fa-warning" v-show="errors.has('address')"></i>
                                </span>
                                <code v-show="errors.has('form-1.address')" id="addresserrmsg" class="help text-danger">{{ errors.first("form-1.address") }}
                                </code>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3" >
                            <b-form-group>
                             <div class="d-flex"> 
                            <label for="city">City</label></div>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text" id="city" name="city" v-model="customer.city" :class="{
                                    input: true,'is-invalid': errors.has('form-1.city'),}" placeholder=""></b-form-input>
                            </b-input-group>
                            <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                <i class="fa fa-warning" v-show="errors.has('city')"></i>
                                </span>
                                <code v-show="errors.has('form-1.city')" id="addresserrmsg" class="help text-danger">{{ errors.first("form-1.address") }}
                                </code>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3" >
                            <b-form-group>
                            <div class="d-flex">  
                            <label for="state">State</label></div>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text" id="state" name="state" v-model="customer.state" :class="{
                                    input: true,'is-invalid': errors.has('form-1.state'),}" placeholder=""></b-form-input>
                            </b-input-group>
                            <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                <i class="fa fa-warning" v-show="errors.has('state')"></i>
                                </span>
                                <code v-show="errors.has('form-1.state')" id="addresserrmsg" class="help text-danger">{{ errors.first("form-1.state") }}
                                </code>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <div class="d-flex">  
                            <label for="bank_name">Bank name</label></div>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" 
                                type="text" id="bank_name" name="bank_name" v-model="customer.bank_name" :class="{
                                    input: true,'is-invalid': errors.has('form-1.bank_name'),}" placeholder="Enter Bank name"></b-form-input>
                            </b-input-group>
                            <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                <i class="fa fa-warning" v-show="errors.has('bank_name')"></i>
                                </span>
                                <code v-show="errors.has('form-1.bank_name')" id="bank_nameerrmsg" class="help text-danger">{{ errors.first("form-1.bank_name") }}
                                </code>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <div class="d-flex">  
                            <label for="bank_account_name">Bank Account Name</label></div>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text"  id="bank_account_name" name="bank_account_name" v-model="customer.bank_account_name" :class="{
                                    input: true,'is-invalid': errors.has('form-1.bank_account_name'),}" placeholder="Enter Bank Account Name"></b-form-input>
                            </b-input-group>
                            <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                <i class="fa fa-warning" v-show="errors.has('bank_account_name')"></i>
                                </span>
                                <code v-show="errors.has('form-1.bank_account_name')" id="bank_account_nameerrmsg" class="help text-danger">{{ errors.first("form-1.bank_account_name") }}
                                </code>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <div class="d-flex">  
                            <label for="bank_branch">Branch Name</label></div>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text" id="bank_branch" name="bank_branch" v-model="customer.bank_branch" :class="{
                                    input: true,'is-invalid': errors.has('form-1.bank_branch'),}" placeholder="Enter Branch Name"></b-form-input>
                            </b-input-group>
                            <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                <i class="fa fa-warning" v-show="errors.has('bank_branch')"></i>
                                </span>
                                <code v-show="errors.has('form-1.bank_branch')" id="bank_brancherrmsg" class="help text-danger">{{ errors.first("form-1.bank_branch") }}
                                </code>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <div class="d-flex">  
                            <label for="account_number">Account number</label></div>
                            <b-input-group class="mb-3">
                                <b-form-input class="input"  type="text" id="account_number" name="account_number" v-model="customer.account_number" :class="{
                                    input: true,'is-invalid': errors.has('form-1.account_number'),}" placeholder="Enter Account number"></b-form-input>
                            </b-input-group>
                            <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                <i class="fa fa-warning" v-show="errors.has('account_number')"></i>
                                </span>
                                <code v-show="errors.has('form-1.account_number')" id="account_numbererrmsg" class="help text-danger">{{ errors.first("form-1.account_number") }}
                                </code>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <div class="d-flex">  
                            <label for="ifsc_code">IFSC Code</label></div>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text" id="ifsc_code" name="ifsc_code" v-model="customer.ifsc_code" :class="{
                                    input: true,'is-invalid': errors.has('form-1.ifsc_code'),}" placeholder="Enter IFSC Code"></b-form-input>
                            </b-input-group>
                            <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                <i class="fa fa-warning" v-show="errors.has('ifsc_code')"></i>
                                </span>
                                <code v-show="errors.has('form-1.ifsc_code')" id="ifsc_codeerrmsg" class="help text-danger">{{ errors.first("form-1.ifsc_code") }}
                                </code>
                            </b-input-group>
                            </b-form-group>
                        </b-col>                        
                    </b-row>
                <hr />
                <br />
                <footer class="column has-text-right">
                    <b-button variant="primary" size="md" type="submit" id="submitButton"
                        >Save
                    </b-button
                    >&nbsp;
                    <b-button
                        variant="primary"
                        size="md"
                        type="submit"
                        @click="$router.push('/vehicleMaster')"
                        >Cancel
                    </b-button>
                </footer>
            </b-form>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
import Router from "vue-router";
const axios = require('axios')

export default {
    data() {
        return {
            name : 'adhoc',
            customer: {
             paymenttype: 'weekly'
            },
            userType :'',
            user_id :'',
            valueAdmin: [],
            optionsAdmin: [],
            fieldAdmin: { text: "name", value: "id" },
            sendadminid: [],
            warehouseData: [],
            warehouseAdmin: [],
            valueWHAdmin :[],
            fieldwhAdmin: { text: "name_wh", value: "id_wh" },
            mailitems :[],
            optionmailid :[],
            pincodes: [],
            pincodeCityData: [],
            transporter_emailid: null,
            transporter_mobilenumber: null,
            transporter_name :null,
            searchableField:true,
            textField:false,
            helper_data:[],
            transporterObj:{},
            transporterCompanyName:null,
            selecttransporterCompanyName:null,
            searchableField:true,
            textField:false,
            errors_GST:false,
            errors_showGST:{},
            removeGST:false,
            showverifybutton : false,
            driver_data:[],
            adminHub:null,
            optionHubid:[],
            hubList:[],
            vehicletypesizetext:false,
            vehicleTypeSizeOptions:[],

            fuelTypeOptions:[],
            getfullname:null,
            selectedBankCheque: '',
            bankFileName: '',
            bankcancelledcheque: '',
            bankFileType: '',
            selectedGstinCertficate: '',
            gstincertificate: '',
            gstinCertficateType: '',
            gstinCertficateFilename: '',
            dlFileName: '',
            dlFileType: '',
            selectedDl: '',
            licence_url:'',
            pucFileUplodFilename: '',
            pucFileUplod: '',
            pucFileUplodType: '',
            puc_url:'',
            selectedRegistration: '',
            registrationFilename: '',
            registrationFileType: '',
            registration_url: '',
            selectedPermit : '',
            permitFileName: '',
            permitFileType: '',
            permit_url: '',
            selectedInsuranceFile: '',
            insurance_url: ''
        }
    },
    created: function() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.userType = userInfo.user_type;
        console.log("YYUUUU", this.userType);
        this.user_id = userInfo.sysusermasterid;
        this.displayAdmin();
        this.adminWiseHubList();       
        this.EmailListing();
        this.getVehicleDetailsList();
        this.getPincodeList();
        let firstname = userInfo.userfirstname ? userInfo.userfirstname : ''
        let lastname = userInfo.userlastname ? userInfo.userlastname : ''
        this.getfullname = firstname +" "+ lastname;
       

    },

    methods: {

        displayAdmin: function() {
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const Obj = {
                sysusermasterid: `${userInfo.sysusermasterid}`,
                usertype: `${userInfo.user_type}`,
            };
            console.log("Obj", Obj);
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/adminListingForVehicle`, Obj)
            .then((result) => {
                if (result.body.returnmsg === "Successful") {
                    this.adminData = result.body.returnvalue;
                    for (let i = 0; i < this.adminData.length; i++) {
                    let admin = {
                        name: this.adminData[i].userfirstname + "" +
                        this.adminData[i].userlastname + " - " +
                        (this.adminData[i].user_type == 2 ? "Admin" : "Super Admin"),
                        id: this.adminData[i].sysusermasterid,
                    };
                    this.optionsAdmin.push(admin);
                    }
                } else {
                    this.adminData = result.body.returnvalue;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        getVehicleDetailsList:function(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const Obj={
            }
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleDetailsList`, Obj)
            .then((result)=>{
                if(result.body && result.body.returnmsg== "Successful"){
                    var fuelTypeData=result.body.returnvalue[0].fuel_Type;
                    var vehicleTypeSizeData=result.body.returnvalue[0].vehicle_type;
                    for(let i=0;i<fuelTypeData.length;++i){
                        this.fuelTypeOptions.push({
                            key:fuelTypeData[i].id,
                            label:fuelTypeData[i].value
                        })
                    }
                    console.log("fuel Type Options-->",this.fuelTypeOptions) 
                     console.log("vehicle Type Size Options-->",this.vehicleTypeSizeOptions)
                               for(let i=0;i<vehicleTypeSizeData.length;++i){
                        this.vehicleTypeSizeOptions.push({
                            key:vehicleTypeSizeData[i].id,
                            label:vehicleTypeSizeData[i].value
                        })
                        if(i==vehicleTypeSizeData.length-1){
                            this.vehicleTypeSizeOptions.push({
                                label:'Other'
                            })
                        }
                    }
                    // console.log("vehicle Type Size Options-->",this.vehicleTypeSizeOptions)
                }
                else{
                    this.fuelTypeOptions=[];
                    this.vehicleTypeSizeOptions=[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
        getPincodeList:function(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj={}
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getPincode`, Obj)
            .then((result)=>{
                if(result.body && result.body.returnmsg== "Successful"){
                    this.pincodeCityData = result.body.returnvalue;                    
                    for(let i=0;i<this.pincodeCityData.length;++i){
                        this.pincodes.push({
                            key:this.pincodeCityData[i].pincode,
                            label:this.pincodeCityData[i].pincode
                        })
                    }
                    console.log("pincodes-->",this.pincodes) 
                }
                else{
                    this.pincodes=[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        
        addVehicleTypeSize:function(){
            this.customer.vehicletypesizetext='';
            if(this.customer.vehicletypesize.label=='Other'){
                this.vehicletypesizetext=true;
            }
            else{
                this.vehicletypesizetext=false;
            }
        },
         
        checkGSTlength(value){
            if (value.length>0) {
                this.showverifybutton=true;
                document.getElementById("submitButton").disabled = true; 
            }
            else{
                this.showverifybutton=false;
                this.customer.transporter_gst_no='';
                this.errors_GST = false;
                this.errors_showGST= {};
                document.getElementById("submitButton").disabled = false;
                this.removeGST=false;
            }
        },

        verifyGSTNo(){
            document.getElementById("overlay").style.display = "block";
            const infoObj = {
                Gstin:this.customer.transporter_gst_no.trim(),
            };
            console.log("infoObj",infoObj);
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/validateGSTNO`, infoObj).then((result)=>{
                console.log("result",result)
                document.getElementById("overlay").style.display = "none";
                if (result.body === "success") {
                document.getElementById("submitButton").disabled = false;
                this.showverifybutton=false;
                this.$fire({
                    text: 'Successful Verify',
                    type: "success",
                    timer: 30000,
                });
                this.errors_GST = false;
                this.errors_showGST.transporter_gst_no=''
                this.removeGST=false;
                } else {
                this.errors_GST = true;
                this.errors_showGST.transporter_gst_no = 'Please Enter Valid Transporter Tin Number / GST Number';
                this.removeGST=true;
                }
            }).catch((ex) => {
                console.log("error", ex);
            });
            
        },

        removevalue(){
            this.showverifybutton=false;
            this.customer.transporter_gst_no='';
            this.errors_GST = false;
            this.errors_showGST= {};
            document.getElementById("submitButton").disabled = false;
            this.removeGST=false;
        },
        
        validateForm(scope) {            
            this.$validator.validateAll(scope).then((result) => {                
                if (result) {
                this.addAgentInfo();
                }
            });
        },

        addAgentInfo : function () {
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

           

            

            if (this.userType == 1 && !this.adminHub) {
                this.$fire({
                    text: "Please Select Hub",
                    type: "warning",
                    timer: 30000,
                    });
                    document.getElementById("overlay").style.display = "none";
                    return false;
            }
                var loginUserid = [];
                loginUserid = this.user_id.toString().split(",");


            let validregex = /(([A-Z]){2}([0-9]){6})|(([A-Z]){2}([0-9]){2}([A-Z]){1}([0-9]){4})|(([A-Z]){2}([0-9]){2}([A-Z]){2}([0-9]){4})|(([A-Z]){3}([0-9]){4})|(([A-Z]){2}([0-9]){3}([A-Z]){1}([0-9]){4})|(([A-Z]){2}([0-9]){2}([A-Z]){3}([0-9]){4})|(([A-Z]{2}[0-9]{4}))/g;

            let validvehicleno = []
            let crosscheck;
           
            //return false;
            
            if ((this.customer.vehicleno).match(validregex) !== null) {
            validvehicleno.push((this.customer.vehicleno).match(validregex));
            crosscheck = ((validvehicleno[0]).toString()).localeCompare(this.customer.vehicleno);
            }
            
            if (validvehicleno.length && crosscheck == 0){ 
            // alert("Successful") 
            }
            else{
            this.$fire({
                text:"Please Enter Valid Vehicle Number",
                type: "warning",
                timer: 30000,
            });
            document.getElementById("overlay").style.display = "none";
            return false;
            }
            

            if(this.customer.transporter_name == null || this.customer.transporter_mobilenumber == null || this.customer.transporter_emailid ==null){
                this.$fire({
                    text:"Please Add Transporter Details From Transporter Master",
                    type: "warning",
                    timer: 30000,
                });
                document.getElementById("overlay").style.display = "none";
                return; 
            }
            this.driver_data.push({
                driverfirstname: this.customer.driverfirstname.trim(),
                driverlastname: this.customer.driverlastname.trim(),
                drivermobilenumber: this.customer.drivermobilenumber.trim(),
                driving_license: this.customer.drivinglicense.trim(),
                driver_license_photo:'',
                driver_license_criteria:'',
                driver_email:'',
                driver_adhar_no:'',
                driver_emergency_no:'',
                driver_adhar_photo:'',
                driver_language:[],
                driver_qualification:[]
            });
            this.helper_data.push({
                helperfirstname: this.customer.helperfirstname,
                helperlastname: this.customer.helperlastname,
                helpermobilenumber: this.customer.helpermobilenumber,
                helperaltmobilenumber: this.customer.helperaltmobilenumber,
                helper_license_number:"",
                helper_license_photo:"",
                helper_license_criteria:"",
                helper_email:"",
                helper_adhar_no:"",
                helper_adhar_photo:""
            });
            const adhocagnetsave = {

                driverfirstname: this.customer && this.customer.driverfirstname ? this.customer.driverfirstname.trim() : "",
                driverlastname: this.customer && this.customer.driverlastname ? this.customer.driverlastname.trim() : "",

                drivermobilenumber: this.customer && this.customer.drivermobilenumber
                    ? Number(this.customer.drivermobilenumber)
                    : 0, // ✅ Joi expects number

                driving_license: this.customer && this.customer.drivinglicense ? this.customer.drivinglicense.trim() : "",
                registration_no: this.customer && this.customer.registration_no ? this.customer.registration_no.trim() : "",

                lastmodifiedby: userInfo && userInfo.sysemailid ? userInfo.sysemailid.trim() : "",

                vehicleno: this.customer && this.customer.vehicleno ? this.customer.vehicleno.trim() : "",
                fueltype: this.customer && this.customer.fueltype ? this.customer.fueltype.key : "",
                password: this.customer && this.customer.password ? this.customer.password.trim() : "",

                contracter_emailid: this.customer && this.customer.transporter_emailid ? this.customer.transporter_emailid.trim() : "",
               
                drivercontractername: this.customer && this.customer.transporter_name ? this.customer.transporter_name.trim() : "",
               
                contractormobilenumber: this.customer && this.customer.transporter_mobilenumber ? this.customer.transporter_mobilenumber.trim() : "",
                vehicletype: "adhoc",
                vehicletypesize: this.vehicletypesizetext === false
                    ? (this.customer && this.customer.vehicletypesize && this.customer.vehicletypesize.key ? String(this.customer.vehicletypesize.key) : "0")
                    : "0",
                vehicletypesizetext: this.vehicletypesizetext === false
                    ? (this.customer && this.customer.vehicletypesize && this.customer.vehicletypesize.label ? this.customer.vehicletypesize.label : "")
                    : (this.customer && this.customer.vehicletypesizetext ? this.customer.vehicletypesizetext.trim() + "ft" : ""),

                transporter_id: this.transporterObj && this.transporterObj.transporter_id ? this.transporterObj.transporter_id : "",
                helper_data: this.helper_data,

                transporter_company_name: (this.customer.transporter_company_name ? this.customer.transporter_company_name.trim() : ""),

                transporter_gstnumber: this.customer && this.customer.transporter_gst_no ? this.customer.transporter_gst_no.trim() : "",

                driver_data: this.driver_data,

                hubid:Number((this.adminHub && this.adminHub.key) ? this.adminHub.key : Number(userInfo.hub_id)), // ✅ Number required

                userfullname: this.getfullname,

                // Optional fields safe for Joi
                pincode: this.customer && this.customer.pincode ? String(this.customer.pincode.label) : "",
                address: this.customer && this.customer.address ? this.customer.address : "",
                city: this.customer && this.customer.city ? this.customer.city : "",
                state: this.customer && this.customer.state ? this.customer.state : "",
                pan: this.customer && this.customer.pan ? this.customer.pan : "",


                usertype: this.userType
                };


            if(this.userType != 1)    {
                adhocagnetsave.sysusermasterid= loginUserid   
            }
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/addVehicleDetailNew`,adhocagnetsave)
            .then((result) => {
                console.log(result);
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                this.$fire({
                    text: result.body.returnvalue,
                    type: "success",
                    timer: 30000,
                });
                this.customer = {};

                this.$router.push("/adhocVehicle");
                // adhocVehicle
                } else {
                this.$fire({
                    text: result.body.returnvalue,
                    type: "error",
                    timer: 30000,
                });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
        
        EmailListing(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            let obj = {
                status : 'Approved',
                isactive : '1'
             }

            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getTransporterEmailIdList`,obj)
            .then(result => {
                if(result.body.returnmsg === "Successful"){
                this.mailitems  = result.body.returnvalue;
                console.log("mailitems",this.mailitems);
                var data = [];
    
                this.mailitems.forEach(function (srData) {
                    data.push({
                    key:srData.transporter_id,
                    label:srData.transporter_company_name
                    });
                });
                this.optionmailid = data;
                console.log( data)
                }
                else{
                  this.mailitems=[];
                  this.optionmailid = [];
                }

            }).catch(ex => {
              console.log('error', ex)
            })
        },
        updateTransporterDetails() {
            if (!this.selecttransporterCompanyName) {
                this.customer.transporter_company_name = '';
                this.customer.transporter_emailid = '';
                this.customer.transporter_name = '';
                this.customer.transporter_mobilenumber = '';
                this.customer.transporter_gst_no = '';
                this.customer.transporter_id = '';
                this.customer.vendortype = '';
                this.customer.account_number = '';
                this.customer.address = '';
                this.customer.adhaar = '';
                this.customer.bank_account_name = '';
                this.customer.bank_branch = '';
                this.customer.bank_name = '';
                this.customer.bankcancelledcheque = '';
                this.customer.city = '';
                this.customer.state = '';
                this.customer.gstincertificate = '';
                this.customer.ifsc_code = '';
                this.customer.pan = '';
                this.customer.warehouseid = '';
                this.customer.pincode = '';

                this.transporterObj = null;

                return;
            }

            const t = this.mailitems.find(
                item => item.transporter_id === this.selecttransporterCompanyName.key
            );

            if (!t) return;
            console.log('updateTransporterDetails',t);
            this.customer.transporter_company_name = t.transporter_company_name;
            this.customer.transporter_emailid = t.transporter_emailid;
            this.customer.transporter_name = t.transporter_name;
            this.customer.transporter_mobilenumber = t.transporter_mobilenumber;
            this.customer.transporter_gst_no =
                !t.transporter_gst_no || t.transporter_gst_no === 'undefined'
                ? ''
                : t.transporter_gst_no;
            this.customer.transporter_id = t.transporter_id;
            this.customer.vendortype = t.vendortype;
            this.customer.account_number = t.account_number;
            this.customer.address = t.address;
            this.customer.adhaar = t.adhaar;
            this.customer.bank_account_name = t.bank_account_name;
            this.customer.bank_branch = t.bank_branch;
            this.customer.bank_name = t.bank_name;
            this.customer.bankcancelledcheque = t.bankcancelledcheque;
            this.customer.city = t.city;
            this.customer.state = t.state;
            this.customer.gstincertificate = t.gstincertificate;
            this.customer.ifsc_code = t.ifsc_code;
            this.customer.pan = t.pan;
            this.customer.warehouseid=t.warehouseid;
            this.customer.pincode= t.pincode;
            this.transporterObj = t; // optional
        },
        
        addemailid_fileds(){
            this.searchableField =! this.searchableField;
            this.transporterCompanyName="";
            this.customer.transporter_emailid = "";
            this.customer.transporter_name = "";
            this.customer.transporter_mobilenumber = "";
            this.customer.transporter_gst_no = "";
        },
        adminWiseHubList(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            let sysId = this.valueAdmin.toString().split(",");
            let obj = {
            }

            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAdminHubListingNew`,obj)
            .then(result => {
                if(result.body.returnmsg === "Successful"){
                this.hubList  = result.body.returnvalue;
                // console.log("hubList",this.hubList);
                var data = [];
    
                this.hubList.forEach(function (srData) {
                    data.push({
                    key:srData.hubid,
                    label:srData.hubname + '-' + srData.hubid
                    });
                });
                this.optionHubid = data;               

                // ✅ NOW safe to set default
                const userdata = localStorage.getItem("userData");
                const userInfo = JSON.parse(userdata);

                if (userInfo && userInfo.hub_id) {                    
                    const selectedHub = this.optionHubid.find(
                        hub => hub.key == userInfo.hub_id
                    );
                    if (selectedHub) {
                      this.adminHub = selectedHub;
                    }
                }
                    

                }
                else{
                  this.hubList=[];
                  this.optionHubid = [];
                }

            }).catch(ex => {
              console.log('error', ex)
            })
        },
        selectBankChequeFile(event){
            this.selectedBankCheque= event.target.files[0];            
            if (this.selectedBankCheque) {
                this.bankFileName = `${event.target.files[0].name}`; 
            }
            this.bankFileType = this.selectedBankCheque.type;
            this.uploadBankCheque(this.selectedBankCheque);
        },

        uploadBankCheque : function () {
            document.getElementById("overlay").style.display = "block";

         var userData = localStorage.getItem('userData');
         var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedBankCheque)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                document.getElementById("overlay").style.display = "none";

                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.bankcancelledcheque=response.data.image_url;                    
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error In Upload Bank check',e);
                
            })
        
        },
        selectGstinCertficateFile(event){
            this.selectedGstinCertficate= event.target.files[0];            
            if (this.selectedGstinCertficate) {
                this.gstinCertficateFilename = `${event.target.files[0].name}`; 
            }
            this.gstinCertficateType = this.selectedGstinCertficate.type;
            this.uploadGstin(this.selectedGstinCertficate);

        },

        uploadGstin : function () {
            document.getElementById("overlay").style.display = "block";

        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedGstinCertficate)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                document.getElementById("overlay").style.display = "none";

                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.gstincertificate=response.data.image_url;                    
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error in upload GSTIN certificate',e);
                
            })
        
        },

        pincodeChange(pincode) {
            this.customer.city = '';
            this.customer.state = '';

            if (!pincode) return;

            const selected = this.pincodeCityData.find(
                item => String(item.pincode) === String(pincode)
            );

            if (!selected) {
                console.log("Pincode not found:", pincode);
                return;
            }

            this.customer.city = selected.city;
            this.customer.state = selected.state;
            },
        
        driverLicenseFileUplod(event){
            this.selectedDl= event.target.files[0];            
            if (this.selectedDl) {
                this.dlFileName = `${event.target.files[0].name}`; 
            }
            this.dlFileType = this.selectedDl.type;
            this.uploadDL(this.selectedDl);
        },
        uploadDL : function () {
            document.getElementById("overlay").style.display = "block";

         var userData = localStorage.getItem('userData');
         var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedDl)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                document.getElementById("overlay").style.display = "none";

                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.licence_url=response.data.image_url;                    
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error In licence check',e);
                
            })
        
        },
        pucFileUplod1(event){
            this.pucFileUplod = event.target.files[0];            
            if (this.pucFileUplod) {
                this.pucFileUplodFilename = `${event.target.files[0].name}`; 
            }
            this.pucFileUplodType = this.pucFileUplod.type;
            this.uploadPuc(this.pucFileUplod);

        },
        uploadPuc : function () {
            document.getElementById("overlay").style.display = "block";

         var userData = localStorage.getItem('userData');
         var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.pucFileUplod)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                document.getElementById("overlay").style.display = "none";

                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.puc_url=response.data.image_url;
                                        
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error In Upload Bank check',e);
                
            })
        
        },
        
        registrationFileUplod(event){
            this.selectedRegistration= event.target.files[0];            
            if (this.selectedRegistration) {
                this.registrationFilename = `${event.target.files[0].name}`; 
            }
            this.registrationFileType = this.selectedRegistration.type;
            this.uploadRegisterFile(this.selectedRegistration);

        },
        uploadRegisterFile : function () {
            document.getElementById("overlay").style.display = "block";

        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedRegistration)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                document.getElementById("overlay").style.display = "none";

                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.registration_url=response.data.image_url;                    
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error in upload register certificate',e);
                
            })
        
        },
        insuranceFileUplod(event){
            this.selectedInsuranceFile= event.target.files[0];            
            if (this.selectedInsuranceFile) {
                this.registrationFilename = `${event.target.files[0].name}`; 
            }
            this.registrationFileType = this.selectedInsuranceFile.type;
            this.uploadInsuranceFile(this.selectedInsuranceFile);

        },
        uploadInsuranceFile:  function () {
            document.getElementById("overlay").style.display = "block";

        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedInsuranceFile)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                document.getElementById("overlay").style.display = "none";

                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.insurance_url=response.data.image_url;                    
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error in upload register certificate',e);
                
            })
        
        },
        permitFileUplod(event){ 
            this.selectedPermit= event.target.files[0];            
            if (this.selectedPermit) {
                this.permitFileName = `${event.target.files[0].name}`; 
            }
            this.permitFileType = this.selectedPermit.type;
            this.uploadPermitFile(this.selectedPermit);
        },
        uploadPermitFile : function () {
            document.getElementById("overlay").style.display = "block";

         var userData = localStorage.getItem('userData');
         var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedPermit)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                document.getElementById("overlay").style.display = "none";

                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.permit_url=response.data.image_url;                    
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error In Upload Permit File',e);
                
            })
        
        }
    },
}
</script>
<style>
.custom-border label{
    overflow: hidden !important;
    line-height: 22px !important;
}
</style>
